module.exports = __webpack_public_path__ + "static/media/plan-image.66fc75d2.png";